/**
 * Vinheria — JavaScript Global
 * Toast, modal CEP (ViaCEP), AJAX add-to-cart, comparação de vinhos
 */
(function() {
  'use strict';

  /* ============================================================
     1. TOAST
     ============================================================ */
  let toastEl = null;
  let toastTimer = null;

  function getToast() {
    if (!toastEl) toastEl = document.getElementById('VinheriaToast');
    return toastEl;
  }

  function showToast(message, duration) {
    duration = duration || 2800;
    const t = getToast();
    if (!t) return;
    t.textContent = message;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), duration);
  }
  window.VinheriaToast = showToast;

  /* ============================================================
     2. ADDRESS MODAL (CEP / ViaCEP)
     ============================================================
     Comportamento:
     - Cliente digita CEP (sem auto-busca)
     - Clica em "Buscar" (ou aperta Enter)
     - Mostra um card com endereço + frete + prazo
     ============================================================ */
  const STORAGE_ADDRESS = 'vinheria_address';

  // Chave de sessão: controla se o pop-up de boas-vindas já foi exibido/pulado
  const SESSION_WELCOME = 'vinheria_welcome_shown';

  function getModal() { return document.getElementById('VinheriaAddressModal'); }
  function getCepInput() { return document.querySelector('[data-vin-cep-input]'); }
  function getCepStatus() { return document.querySelector('[data-vin-cep-status]'); }
  function getCepResult() { return document.querySelector('[data-vin-cep-result]'); }

  function openAddressModal() {
    const m = getModal();
    if (!m) return;
    m.classList.add('open');
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      const i = getCepInput();
      if (i) i.focus();
    }, 350);
  }

  function closeAddressModal() {
    const m = getModal();
    if (!m) return;
    m.classList.remove('open');
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ----------------------------------------------------------
     POP-UP DE BOAS-VINDAS
     Abre automaticamente na primeira visita de cada sessão,
     a menos que o cliente já tenha um CEP salvo no localStorage.
     Usa sessionStorage para não aparecer mais de uma vez por aba.
  ---------------------------------------------------------- */
  function maybeShowWelcomePopup() {
    // Já exibido/pulado nesta sessão → nada a fazer
    if (sessionStorage.getItem(SESSION_WELCOME)) return;

    // Cliente já tem CEP salvo → não precisa pedir de novo
    if (localStorage.getItem(STORAGE_ADDRESS)) {
      sessionStorage.setItem(SESSION_WELCOME, '1');
      return;
    }

    // Marca a sessão como "exibido" antes de abrir
    sessionStorage.setItem(SESSION_WELCOME, '1');

    // Ativa o modo welcome no modal (muda visual do header)
    const m = getModal();
    if (m) m.classList.add('welcome');

    // Pequeno delay para a página terminar de renderizar
    setTimeout(openAddressModal, 600);
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-vin-address-open]')) {
      e.preventDefault();
      // Ao abrir manualmente, sai do modo welcome (se estiver)
      const m = getModal();
      if (m) m.classList.remove('welcome');
      openAddressModal();
    }
    const m = getModal();
    if (m && m.classList.contains('open') && e.target.classList.contains('vin-address-modal-overlay')) {
      closeAddressModal();
    }
    if (e.target.closest('[data-vin-cep-submit]')) {
      e.preventDefault();
      buscarCEP();
    }
    if (e.target.closest('[data-vin-cep-confirm]')) {
      e.preventDefault();
      closeAddressModal();
    }
    // Botão "Pular por agora" — fecha e sai do modo welcome
    if (e.target.closest('[data-vin-welcome-skip]')) {
      e.preventDefault();
      const m2 = getModal();
      if (m2) m2.classList.remove('welcome');
      closeAddressModal();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const m = getModal();
      if (m && m.classList.contains('open')) closeAddressModal();
    }
  });

  // Máscara de CEP — APENAS formata, NÃO busca automaticamente
  document.addEventListener('input', function(e) {
    if (!e.target.matches('[data-vin-cep-input]')) return;
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 8) value = value.substring(0, 8);
    if (value.length > 5) value = value.substring(0, 5) + '-' + value.substring(5);
    e.target.value = value;
    // Esconde o card de resultado se o cliente começar a editar de novo
    const result = getCepResult();
    if (result) result.hidden = true;
  });

  // Enter dispara a busca
  document.addEventListener('keypress', function(e) {
    if (e.key === 'Enter' && e.target.matches('[data-vin-cep-input]')) {
      e.preventDefault();
      buscarCEP();
    }
  });

  function setCepStatus(text, type) {
    const s = getCepStatus();
    if (!s) return;
    s.textContent = text || '';
    s.className = 'vin-cep-status' + (type ? ' ' + type : '');
  }

  function setLoading(state) {
    const btn = document.querySelector('[data-vin-cep-submit]');
    if (!btn) return;
    btn.classList.toggle('is-loading', !!state);
    btn.disabled = !!state;
  }

  // Determina a zona baseado no endereço retornado pelo ViaCEP
  // Tabela de frete: [cep_inicial, cep_final, frete_6gar(7.5kg), frete_12gar(15kg), dias]
  // dias pode ser número (dias úteis) ou string (ex: "50-55 min" para entrega expressa)
  // Pesos reais: 1 garrafa ≈ 1,25 kg com embalagem → 6 gar = 7,5 kg · 12 gar = 15 kg
  const FRETE_TABLE = [
    [1000000,5999999,22.0,33.0,"50-55 min"],
    [6000000,6299999,22.0,33.0,2],
    [6300000,6399999,22.0,33.0,2],
    [6400000,6499999,22.0,33.0,"50-55 min"],
    [6500000,6599999,22.0,33.0,"50-55 min"],
    [6600000,6999999,22.0,33.0,2],
    [7000000,7999999,22.0,33.0,"50-55 min"],
    [8000000,9999999,22.0,33.0,"50-55 min"],
    [11000000,19999999,22.0,33.0,2],
    [20000000,26600999,49.28,92.4,4],
    [26601000,28999999,49.28,92.4,5],
    [29000000,29099999,66.88,125.4,8],
    [29100000,29999999,66.88,125.4,13],
    [30000000,31999999,49.76,93.3,6],
    [32000000,39999999,49.76,93.3,6],
    [40000000,44470999,94.08,176.4,15],
    [44471000,48999999,94.08,176.4,14],
    [49000000,49099999,68.0,127.5,9],
    [49100000,49999999,68.0,127.5,14],
    [50000000,54999999,68.0,127.5,10],
    [55000000,56999999,68.0,127.5,14],
    [57000000,57099999,68.56,128.55,8],
    [57100000,57999999,68.56,128.55,13],
    [58000000,58099999,68.0,127.5,12],
    [58100000,58999999,68.0,127.5,14],
    [59000000,59099999,80.0,150.0,11],
    [59100000,59999999,80.0,150.0,14],
    [60000000,61900999,68.0,127.5,9],
    [61901000,63999999,68.0,127.5,9],
    [64000000,64099999,68.0,127.5,11],
    [64100000,64999999,68.0,127.5,14],
    [65000000,65109999,68.0,127.5,9],
    [65110000,65999999,68.0,127.5,9],
    [66000000,66999999,68.0,127.5,12],
    [67000000,68899999,68.0,127.5,14],
    [68900000,68914999,68.0,127.5,9],
    [68915000,68999999,68.0,127.5,9],
    [69000000,69099999,72.24,135.45,14],
    [69100000,69299999,72.24,135.45,14],
    [69300000,69339999,68.0,127.5,13],
    [69340000,69389999,68.0,127.5,14],
    [69400000,69899999,72.24,135.45,14],
    [69900000,69920999,68.0,127.5,10],
    [69921000,69999999,68.0,127.5,17],
    [70000000,70999999,37.76,70.8,4],
    [71000000,72799999,37.76,70.8,4],
    [72800000,72999999,53.52,100.35,10],
    [73000000,73699999,37.76,70.8,8],
    [73700000,74000999,53.52,100.35,10],
    [74000000,74899999,53.52,100.35,8],
    [74900000,76799999,53.52,100.35,10],
    [76800000,76833999,95.36,178.8,14],
    [76834000,76999999,95.36,178.8,14],
    [77000000,77270999,65.6,123.0,11],
    [77300000,77995999,65.6,123.0,14],
    [78000000,78109999,68.0,127.5,7],
    [78110000,78899999,68.0,127.5,14],
    [79000000,79124999,68.0,127.5,7],
    [79125000,79999999,68.0,127.5,14],
    [80000000,83800999,77.36,145.05,12],
    [83801000,87999999,77.36,145.05,14],
    [88000000,88469999,108.0,202.5,8],
    [88470000,89999999,108.0,202.5,10],
    [90000000,94900999,76.0,142.5,14],
    [94901000,99999999,76.0,142.5,14]
  ];

  function consultarFrete(cepStr) {
    const num = parseInt((cepStr || '').replace(/\D/g, ''), 10);
    if (isNaN(num)) return null;
    const row = FRETE_TABLE.find(r => num >= r[0] && num <= r[1]);
    if (!row) return null;
    return { f6: row[2], f12: row[3], dias: row[4] };
  }

  function formatDias(dias) {
    if (typeof dias === 'string') return dias;
    return dias + (dias === 1 ? ' dia útil' : ' dias úteis');
  }

  function determinarZona(uf, cidade, cep) {
    const m = getModal();
    if (!m) return null;

    const cidadeNorm = (cidade || '').toLowerCase().trim();
    const ufNorm = (uf || '').toUpperCase().trim();

    // CEP com prazo "50-55 min" na tabela → sempre Motoboy
    if (cep) {
      const freteExpress = consultarFrete(cep);
      if (freteExpress && typeof freteExpress.dias === 'string') {
        return {
          id: 'express',
          fee: parseFloat(m.dataset.zoneCapitalFee) || 15,
          time: freteExpress.dias,
          mode: m.dataset.zoneCapitalMode || 'Motoboy',
          modeIcon: '🛵'
        };
      }
    }

    if (ufNorm === 'SP' && cidadeNorm === 'são paulo') {
      return {
        id: 'capital',
        fee: parseFloat(m.dataset.zoneCapitalFee) || 15,
        time: m.dataset.zoneCapitalTime || 'Até 2 horas',
        mode: m.dataset.zoneCapitalMode || 'Motoboy',
        modeIcon: '🛵'
      };
    }

    const motoboyCidades = [
      'barueri', 'santana de parnaíba',
      'santo andré', 'são bernardo do campo', 'são caetano do sul',
      'diadema', 'mauá', 'ribeirão pires', 'rio grande da serra'
    ];
    if (ufNorm === 'SP' && motoboyCidades.includes(cidadeNorm)) {
      return {
        id: 'motoboy_sp',
        fee: parseFloat(m.dataset.zoneCapitalFee) || 15,
        time: m.dataset.zoneCapitalTime || 'Até 2 horas',
        mode: m.dataset.zoneCapitalMode || 'Motoboy',
        modeIcon: '🛵'
      };
    }

    if (ufNorm === 'SP') {
      return {
        id: 'sp',
        fee: parseFloat(m.dataset.zoneSpFee) || 30,
        time: m.dataset.zoneSpTime || '2-3 dias úteis',
        mode: 'Transportadora',
        modeIcon: '🚚',
        disclaimer: 'Para sua região, enviamos apenas por transportadora'
      };
    }

    return {
      id: 'br',
      fee: parseFloat(m.dataset.zoneBrFee) || 40,
      time: m.dataset.zoneBrTime || '5-7 dias úteis',
      mode: 'Transportadora',
      modeIcon: '🚚',
      disclaimer: 'Para sua região, enviamos apenas por transportadora'
    };
  }

  function formatBRL(v) {
    return 'R$ ' + Number(v).toFixed(2).replace('.', ',');
  }

  function renderResult(address, zone) {
    const m = getModal();
    if (!m) return;

    // Endereço
    const street = document.querySelector('[data-vin-cep-street]');
    const area = document.querySelector('[data-vin-cep-area]');
    if (street) {
      street.textContent = address.logradouro
        ? address.logradouro + (address.bairro ? ', ' + address.bairro : '')
        : (address.bairro || 'CEP ' + address.cep);
    }
    if (area) {
      area.textContent = (address.cidade || '') + (address.uf ? ' - ' + address.uf : '');
    }

    // Frete pela tabela real
    const frete = consultarFrete(address.cep);

    // Cards de caixa 6 e 12 garrafas
    function makeBox(label, kg, preco) {
      var wrap = document.createElement('div');
      wrap.style.cssText = 'flex:1;background:var(--cream-soft);border:1px solid var(--line);border-radius:12px;padding:10px;';
      var title = document.createElement('div');
      title.style.cssText = 'font-size:11px;font-weight:600;color:var(--ink);margin-bottom:2px;';
      title.textContent = label;
      var meta = document.createElement('div');
      meta.style.cssText = 'font-size:10px;color:var(--ink-soft);margin-bottom:4px;';
      meta.textContent = kg + 'kg - ' + formatDias(consultarFrete(address.cep) ? consultarFrete(address.cep).dias : '');
      var price = document.createElement('div');
      price.style.cssText = 'font-size:17px;font-weight:700;color:var(--burgundy);';
      price.textContent = preco;
      wrap.appendChild(title);
      wrap.appendChild(meta);
      wrap.appendChild(price);
      return wrap;
    }

    var boxesEl = document.querySelector('[data-vin-cep-boxes]');
    if (boxesEl && frete) {
      var diasStr = formatDias(frete.dias);
      boxesEl.innerHTML = '';
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;gap:10px;margin-top:10px;';
      row.appendChild(makeBox('6 garrafas', '7,5 ', formatBRL(frete.f6)));
      row.appendChild(makeBox('12 garrafas', '15 ', formatBRL(frete.f12)));
      boxesEl.appendChild(row);
      boxesEl.hidden = false;
    }

    // Campos legados (modo, taxa, prazo) — mantidos para compatibilidade
    const modeIcon = document.querySelector('[data-vin-cep-mode-icon]');
    const mode = document.querySelector('[data-vin-cep-mode]');
    if (modeIcon) modeIcon.textContent = zone ? (zone.modeIcon || '') : '';
    if (mode && zone) {
      mode.textContent = zone.mode;
      if (zone.disclaimer) {
        mode.innerHTML = zone.mode + '<br><span style="font-size:11px;color:var(--ink-soft);font-weight:400;">' + zone.disclaimer + '</span>';
      }
    }

    const fee = document.querySelector('[data-vin-cep-fee]');
    if (fee && frete) fee.textContent = formatBRL(frete.f6);

    const time = document.querySelector('[data-vin-cep-time]');
    if (time && frete) time.textContent = formatDias(frete.dias);

    // Frete grátis
    const freeShip = document.querySelector('[data-vin-cep-freeship]');
    const freeShipText = document.querySelector('[data-vin-cep-freeship-text]');
    const threshold = parseFloat(m.dataset.freeShippingThreshold) || 1500;

    if (freeShip && freeShipText) {
      const ufAtual = (address.uf || '').toUpperCase().trim();
      const isEligible = ufAtual === 'SP' || ufAtual === 'DF';
      if (isEligible) {
        freeShipText.textContent = 'Frete grátis em compras acima de ' + formatBRL(threshold);
        freeShip.hidden = false;
      } else {
        freeShip.hidden = true;
      }
    }

    // Mostra o card
    const result = getCepResult();
    if (result) result.hidden = false;
  }

  function buscarCEP() {
    const input = getCepInput();
    if (!input) return;
    const cep = input.value.replace(/\D/g, '');

    if (cep.length !== 8) {
      setCepStatus('CEP deve ter 8 dígitos', 'error');
      return;
    }

    setCepStatus('');
    setLoading(true);
    const result = getCepResult();
    if (result) result.hidden = true;

    fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(r => r.json())
      .then(data => {
        setLoading(false);
        if (data.erro) {
          setCepStatus('CEP não encontrado. Verifique e tente novamente.', 'error');
          return;
        }
        const address = {
          cep: data.cep,
          logradouro: data.logradouro || '',
          bairro: data.bairro || '',
          cidade: data.localidade || '',
          uf: data.uf || ''
        };

        const zone = determinarZona(address.uf, address.cidade, address.cep);
        const freteReal = consultarFrete(address.cep);
        if (freteReal && zone) {
          zone.time = formatDias(freteReal.dias);
        }
        address.zone = zone;

        renderResult(address, zone);
        localStorage.setItem(STORAGE_ADDRESS, JSON.stringify(address));
        updateLocationDisplay(address);
        // Notifica outras partes do site (ex: faixa de frete grátis na sacola)
        window.dispatchEvent(new CustomEvent('vinheria:address-updated', { detail: address }));
      })
      .catch(() => {
        setLoading(false);
        setCepStatus('Erro de conexão. Tente novamente.', 'error');
      });
  }

  function updateLocationDisplay(address) {
    const els = document.querySelectorAll('[data-vin-location-value]');
    if (!els.length) return;
    let text;
    if (address.bairro && address.cidade) text = address.bairro + ', ' + address.cidade;
    else if (address.cidade) text = address.cidade + ' · ' + address.uf;
    else text = 'CEP ' + address.cep;
    if (text.length > 28) text = text.substring(0, 26) + '…';
    els.forEach(el => el.textContent = text);
  }

  /* ============================================================
     3. AJAX ADD TO CART
     ============================================================ */
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-vin-add-to-cart]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    /* Lê a quantidade: do data-quantity-source (página de produto)
       ou usa 1 como padrão (cards de listagem) */
    let quantity = 1;
    const qtySourceId = btn.dataset.quantitySource;
    if (qtySourceId) {
      const qtyEl = document.getElementById(qtySourceId);
      if (qtyEl) {
        quantity = parseInt(qtyEl.dataset.qty || qtyEl.textContent, 10) || 1;
      }
    }

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    try {
      const res = await fetch(window.shopUrls.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: quantity }]
        })
      });
      const data = await res.json();
      if (!res.ok) {
        showToast(data.description || 'Erro ao adicionar.');
        return;
      }
      const product = data.items ? data.items[0] : data;
      showToast('✓ ' + (product.product_title || product.title || 'Produto') + ' adicionado');
      await updateCartBadge();
      window.dispatchEvent(new CustomEvent('vinheria:cart-updated'));
      btn.style.transform = 'scale(1.2)';
      setTimeout(() => btn.style.transform = '', 200);
    } catch (err) {
      showToast('Erro de conexão. Tente novamente.');
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });

  async function updateCartBadge() {
    try {
      const res = await fetch(window.shopUrls.cart_url + '.js');
      const cart = await res.json();
      const badges = document.querySelectorAll('[data-vin-cart-count]');
      badges.forEach(b => {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? '' : 'none';
      });
    } catch (e) {}
  }

  /* ============================================================
     4. COMPARAÇÃO DE VINHOS (max 3)
     ============================================================ */
  const STORAGE_COMPARE = 'vinheria_compare';
  const MAX_COMPARE = 2;

  function getCompareList() {
    try {
      const raw = localStorage.getItem(STORAGE_COMPARE);
      const list = raw ? JSON.parse(raw) : [];
      return Array.from(new Set(list.map(x => parseInt(x, 10)).filter(Boolean)));
    } catch (e) { return []; }
  }

  function setCompareList(list) {
    localStorage.setItem(STORAGE_COMPARE, JSON.stringify(list));
    updateCompareUI();
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-vin-compare-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const id = parseInt(btn.dataset.productId, 10);
    if (!id) return;

    const list = getCompareList();
    const idx = list.indexOf(id);
    if (idx !== -1) {
      list.splice(idx, 1);
      setCompareList(list);
      btn.classList.remove('active');
      showToast('Removido da comparação');
    } else {
      if (list.length >= MAX_COMPARE) {
        showToast('Máximo ' + MAX_COMPARE + ' vinhos. Remova um antes de adicionar.');
        return;
      }
      list.push(id);
      setCompareList(list);
      btn.classList.add('active');
      showToast('✓ Adicionado para comparar (' + list.length + '/' + MAX_COMPARE + ')');
    }
  });

  function updateCompareUI() {
    const list = getCompareList();
    const count = list.length;
    const bar = document.getElementById('VinheriaCompareBar');
    const countEl = document.querySelector('[data-vin-compare-count]');
    if (countEl) countEl.textContent = count;
    if (bar) bar.classList.toggle('show', count > 0);

    document.querySelectorAll('[data-vin-compare-toggle]').forEach(b => {
      const pid = parseInt(b.dataset.productId, 10);
      b.classList.toggle('active', list.indexOf(pid) !== -1);
    });
  }

  /* ============================================================
     5. INICIALIZAÇÃO
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    // Restaura endereço salvo
    try {
      const saved = localStorage.getItem(STORAGE_ADDRESS);
      if (saved) {
        const address = JSON.parse(saved);
        updateLocationDisplay(address);
        const zone = determinarZona(address.uf, address.cidade, address.cep);
        const freteRestore = consultarFrete(address.cep);
        if (freteRestore && zone) {
          zone.time = formatDias(freteRestore.dias);
        }
        renderResult(address, zone);
        const input = getCepInput();
        if (input && address.cep) input.value = address.cep;
      }
    } catch (e) {}

    // Restaura estado da comparação
    updateCompareUI();

    // Atualiza badge da sacola
    updateCartBadge();

    // Pop-up de boas-vindas (apenas se não tiver CEP salvo e não tiver sido visto nesta sessão)
    maybeShowWelcomePopup();
  });

  // Sincroniza entre abas
  window.addEventListener('storage', function(e) {
    if (e.key === STORAGE_COMPARE) updateCompareUI();
    if (e.key === STORAGE_ADDRESS && e.newValue) {
      try { updateLocationDisplay(JSON.parse(e.newValue)); } catch (err) {}
    }
  });

})();